//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        toggleLabel: {
            type: String,
            default: null
        },
        labelLeft: {
            type: String,
            default: "No"
        },
        labelRight: {
            type: String,
            default: "Yes"
        },
        initialToggle: false,
        toggleSwitchID: {
            type: String
        }
    },
    data: function data() {
        return {
            checked: false
        };
    },
    mounted: function mounted() {
        // this fixes whether boolean or string, true/false or 0/1
        if (this.initialToggle === 1) {
            this.checked = true;
        } else if (this.initialToggle === 0) {
            this.checked = false;
        } else if (this.initialToggle) {
            this.checked = true;
        } else {
            this.checked = false;
        }
    },

    watch: {
        initialToggle: function initialToggle(val) {
            // this fixes whether boolean or string, true/false or 0/1
            if (val == 1) {
                this.checked = true;
            } else if (val == 0) {
                this.checked = false;
            } else if (val) {
                this.checked = true;
            } else {
                this.checked = false;
            }
        }
    },
    methods: {
        onToggle: function onToggle() {
            this.$emit('input', this.checked);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/cms/Toggle.vue
// module id = 3peJ
// module chunks = 0 1